/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * states that a module can have with students: assigned > submitted > graded
 */
export type StudentWorkflowState = (typeof StudentWorkflowState)[keyof typeof StudentWorkflowState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentWorkflowState = {
  assigned: 'assigned',
  submitted: 'submitted',
  graded: 'graded',
} as const;
